interface ValidationInfoItemModel {
  targetElementId?: string;
  targetElementName?: string;
  validators?: ValidatorItemModel[];
}

interface ValidatorItemModel {
  description?: string;
  type?: string;
  model: {
    message?: string;
  };
}

interface ValidateResultModel {
  isValid?: boolean;
  message?: string;
}

(() => {
  const twoColumnBg = document.querySelector<HTMLElement>(".fm-o-two-column--bg-image");
  const epiFormBg = document.querySelector<HTMLElement>(".fm-o-epi-form__bg");
  const epiForm = twoColumnBg?.querySelector(".fm-o-epi-form") || epiFormBg?.closest(".fm-o-epi-form");
  const boundingRect = epiForm?.getBoundingClientRect();
  const spacingRight = window.innerWidth - (boundingRect?.right || 0);

  const resizeObserver = new ResizeObserver(() => {
    processSvg(spacingRight);
  });

  if (twoColumnBg) {
    resizeObserver.observe(twoColumnBg);
  } else if (epiFormBg) {
    resizeObserver.observe(epiFormBg);
  }

  const processSvg = (spacingRight: number) => {
    const svgShapes = document.querySelectorAll<HTMLElement>(".bg-svg-shape");

    svgShapes.forEach((svg) => {
      const path = svg.querySelector("path");
      const WIDTH_BASE = 433;
      const svgWidth = svg.clientWidth;
      const svgHeight = svg.clientHeight;
      const SPACING_MAX = 50;
      const offset = (30 * svgWidth) / WIDTH_BASE;
      const centerX = 0;
      const centerY = svgHeight / 2;
      const point1X = svgWidth - spacingRight + SPACING_MAX;
      const point1Y = svgHeight;
      const controlPointCoord1 = computePointOnLine(centerX, centerY, point1X, point1Y, offset);
      const point2X = svgWidth - spacingRight + SPACING_MAX;
      const point2Y = 0;
      const controlPointCoord2 = computePointOnLine(centerX, centerY, point2X, point2Y, offset);

      svg?.setAttribute("width", `${svgWidth}`);
      svg?.setAttribute("height", `${svgHeight}`);
      svg?.setAttribute("viewBox", `0 0 ${svgWidth} ${svgHeight}`);
      path?.setAttribute("d", `M ${point2X},${point2Y} ${svgWidth},0 ${svgWidth},${svgHeight} ${point1X},${point1Y} ${controlPointCoord1.x},${controlPointCoord1.y} Q ${centerX},${centerY} ${controlPointCoord2.x},${controlPointCoord2.y}z`);
    });
  };

  /**
   * Computes the coordinate of a point on the line defined by two points A(x1, y1) and B(x2, y2),
   * given the x-coordinate (xCoord) of the point.
   */
  const computePointOnLine = (x1: number, y1: number, x2: number, y2: number, xCoord: number) => {
    // Calculate the slope of the line defined by A and B.
    const slope = (y2 - y1) / (x2 - x1);

    // Determine the y-coordinate using the line equation: y - y1 = slope * (x - x1).
    const yCoord = y1 + (xCoord - x1) * slope;

    return { x: xCoord, y: yCoord };
  };

  /**
   * Form validation
   */
  class ValidateForm {
    requireValidatorConfigKey: string;
    emailValidatorConfigKey: string;
    numberValidatorConfigKey: string;
    timers: { [key: string]: ReturnType<typeof setTimeout> | null };

    constructor() {
      this.requireValidatorConfigKey = "EPiServer.Forms.Implementation.Validation.RequiredValidator";
      this.emailValidatorConfigKey = "EPiServer.Forms.Implementation.Validation.EmailValidator";
      this.numberValidatorConfigKey = "EPiServer.Forms.Implementation.Validation.NumericValidator";
      this.timers = {};
    }

    // this is come from EPIForms
    getRequireValidatorConfig() {
      return {
        type: this.requireValidatorConfigKey,
        model: {
          message: "This field is required.",
          validationCssClass: "ValidationRequired",
          additionalAttributes: {
            required: "",
            "aria-required": "true",
          },
        },
      };
    }

    // this is come from EPIForms
    getEmailValidatorConfig() {
      return {
        type: this.emailValidatorConfigKey,
        model: {
          jsPattern:
            "^((([a-zA-Z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-zA-Z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-zA-Z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-zA-Z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-zA-Z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-zA-Z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-zA-Z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-zA-Z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-zA-Z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-zA-Z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$",
          message: "Enter a valid email address.",
        },
      };
    }

    // this is come from EPIForms
    getNumberValidatorConfig() {
      return {
        type: this.numberValidatorConfigKey,
        description: null,
        model: {
          message: "Enter a valid number.",
          validationCssClass: null,
          additionalAttributes: null,
        },
      };
    }

    init() {
      // code third party that we can't control so put in a try catch block
      try {
        this.addEventToForm();
      } catch (error) {
        console.log(error);
      }
    }

    addEventToForm() {
      const forms = document.querySelectorAll<HTMLElement>(".fm-o-epi-form--label-separate .EPiServerForms");

      forms.forEach((form) => {
        const formId = form.getAttribute("id");
        const formInfo = window.epi.EPiServer.Forms[`${formId}`];
        const validationInfo = formInfo.ValidationInfo as ValidationInfoItemModel[];

        this.addEventToElementByValidationInfo(validationInfo);
        this.addEventToNonValidateElement(form);
      });
    }

    addEventToNonValidateElement(form: HTMLElement) {
      const elements = form.querySelectorAll<HTMLElement>('.FormTextbox:not(.ValidationRequired)');

      elements.forEach((element) => {
        const input = element.querySelector<HTMLInputElement>('input, textarea');
        input?.addEventListener("input", this.processNonValidateFormElementInput.bind(this, input));
      });
    }

    processNonValidateFormElementInput(input: HTMLInputElement) {
      const value = input.value.trim();
      const parent = input.closest(".Form__Element");

      if (value) {
        parent?.classList.add("ValidationSuccess");
      } else {
        parent?.classList.remove("ValidationSuccess");
      }
    }

    addEventToElementByValidationInfo(validationInfo?: ValidationInfoItemModel[]) {
      validationInfo?.forEach((info) => {
        const name = info?.targetElementName;

        if (!name) {
          return;
        }

        const element = document.querySelector<HTMLInputElement>('[name="' + name + '"]');

        element?.addEventListener("input", this.processFormElementInput.bind(this, info, element));

        this.addCustomElementClass(element);
      });
    }

    addCustomElementClass(element?: HTMLElement | null) {
      const parent = element?.closest(".Form__Element");
      const label = parent?.querySelector("label");

      if (label?.textContent?.toLowerCase().includes('email')) {
        parent?.classList.add("FormEmail");
      }
    }

    processFormElementInput(info?: ValidationInfoItemModel, element?: HTMLInputElement) {
      const id = element?.id;

      if (!id) {
        return;
      }

      this.timers[id] && window.clearTimeout(this.timers[id]);

      this.timers[id] = setTimeout(() => {
        const validators = info?.validators;

        validators?.every((validator) => {
          const validate = this.validateFormElement(element, validator, info);

          if (!validate?.isValid) {
            this.showErrorMessage(element, validate?.message);

            return false;
          } else {
            this.removeErrorMessage(element);

            return true;
          }
        });
      }, 300);
    }

    validateFormElement(element?: HTMLInputElement, validator?: ValidatorItemModel, info?: ValidationInfoItemModel) {
      let result: ValidateResultModel = { isValid: true, message: "" };
      const id = element?.id;

      if (!id) {
        return;
      }

      switch (validator?.type) {
        case this.requireValidatorConfigKey:
          result = this.requireValidate(id, element?.value);
          break;

        case this.emailValidatorConfigKey:
          result = this.emailValidValidate(id, element?.value);
          break;

        case this.numberValidatorConfigKey:
          result = this.numberValidValidate(id, element?.value);
          break;
        default:
          break;
      }

      return result;
    }

    numberValidValidate(id: string, value?: string) {
      const numberValidator = window.epi.EPiServer.Forms.Validators[this.numberValidatorConfigKey];
      const numberValidateResult = numberValidator(id, value, this.getNumberValidatorConfig()) as ValidateResultModel;

      return numberValidateResult;
    }

    requireValidate(id: string, value?: string) {
      const requireValidator = window.epi.EPiServer.Forms.Validators[this.requireValidatorConfigKey];
      const requireValidateResult = requireValidator(id, value, this.getRequireValidatorConfig()) as ValidateResultModel;

      return requireValidateResult;
    }

    emailValidValidate(id: string, value?: string) {
      const emailValidator = window.epi.EPiServer.Forms.Validators[this.emailValidatorConfigKey];
      const emailValidateResult = emailValidator(id, value, this.getEmailValidatorConfig()) as ValidateResultModel;

      return emailValidateResult;
    }

    showErrorMessage(element: HTMLElement, message?: string) {
      const form = element.closest(".EPiServerForms");
      const parent = element.closest(".Form__Element");
      const messageEl = parent?.querySelector<HTMLElement>(".Form__Element__ValidationError");

      form?.classList.add("ValidationFail");
      parent?.classList.add("ValidationFail");
      parent?.classList.remove("ValidationSuccess");

      if (messageEl) {
        messageEl.removeAttribute("style");
        messageEl.textContent = `${message ?? ""}`;
      }
    }

    removeErrorMessage(element: HTMLElement) {
      const form = element.closest(".EPiServerForms");
      const parent = element.closest(".Form__Element");
      const messageEl = parent?.querySelector<HTMLElement>(".Form__Element__ValidationError");

      form?.classList.remove("ValidationFail");
      parent?.classList.remove("ValidationFail");
      parent?.classList.add("ValidationSuccess");

      if (messageEl) {
        messageEl.style.display = "none";
        messageEl.textContent = "";
      }
    }
  }

  // run function
  new ValidateForm().init();

  // process quote form
  class QuoteForm {
    selector: string;

    constructor(selector: string) {
      this.selector = selector;
    }

    init() {
      this.addEvents();
    }

    addEvents() {
      if (!window.$$epiforms) {
        return;
      }

      window.$$epiforms(this.selector).on('formsStartSubmitting', this.handleFormSubmitting.bind(this));
    }


    handleFormSubmitting(event: Event) {
      if (!window.dataLayer) {
        return;
      }

      const form = event.target as HTMLFormElement;
      const emailEl = form.querySelector<HTMLInputElement>('.FormEmail input');
      const phoneEl = form.querySelector<HTMLInputElement>('.FormTextbox--Number input');

      window.dataLayer.push({
        event: 'form',
        form: {
          action: 'submit',
          id: 'epiform',
          name: 'get a quote',
          type: 'lead gen',
          category: 'contact forms',
          success: true,
          phone: phoneEl?.value || '',
          email: emailEl?.value || '',
        },
      });
    }
  }

  // create instance quote form
  new QuoteForm('.fm-o-epi-form--label-separate .EPiServerForms').init();
})();
